import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { mainnet, sepolia, polygon } from "wagmi/chains";
import { http } from "wagmi";

export const config = getDefaultConfig({
  appName: "VerifiLite",
  appDescription: "Trustless Identity Verification Widget",
  appUrl: "https://widget.verifilite.com", // Replace with your production URL
  appIcon: "https://widget.verifilite.com/logo.png", // Replace with your logo URL
  projectId: "1f38c426af3fbb085115edc1edab80e8", // Get from https://cloud.walletconnect.com
  chains: [mainnet, sepolia, polygon],
  transports: {
    [mainnet.id]: http(),
    [sepolia.id]: http(),
    [polygon.id]: http(),
  },
  ssr: true,
});
